import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { KeycloakService } from '../auth/keycloak.service';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private keycloakService = inject(KeycloakService);
  private router = inject(Router);


  canActivate(): Observable<boolean | UrlTree> {
    if (this.keycloakService.isLoggedIn()) {
      if (environment.enableOtp) {
        const context = this.keycloakService.getUserContext();
        if (context?.otpRequired && !context.otpVerified) {
          return of(this.router.createUrlTree(['/login/otp']));
        }
      }
      return of(true);
    }

    // Redirect to the branded login page first
    return of(this.router.createUrlTree(['/login']));
  }
}
